import BackboneElement from './BackboneElement';
import Coding from './types/Coding';
import merge from 'lodash/merge';

export default class BN_SuperBillValueCodeList extends BackboneElement {
    static __className = 'BN_SuperBillValueCodeList';

    __objectStructure = {
        code: Coding,
        amount: Number,
    };

    constructor(constructJson, className = 'BN_SuperBillValueCodeList') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
